const state = {
  previewInfo: {
    imgList: [],
    currentIndex: 0,
    isRx: false,
    isFuzzy: false,
  },
  platform: '',
};

const mutations = {
  SET_PREVIEW(state, payload) {
    state.previewInfo = payload;
  },
  SET_PLATFORM(state, payload) {
    state.platform = payload;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
